.picker-pointer .pointer-drag {
  position: absolute;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  top: -17.5px;
  left: -15.5px;
  background-color: var(--main-text);
  color: white;
  text-align: center;
  line-height: 35px;
}

.draggable {
  cursor: move;
}

.picker-center {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--main-text);
  transform: translate(-50%, -50%);
}

.picker-pointer {
  width: 4px;
  height: 110px;
  top: 20px;
  transform-origin: center bottom;
  left: 50%;
  position: absolute;
  background-color: var(--main-text);
}

.picker-pointer.animation {
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}
